import { render } from "./mvt-checkbox.vue?vue&type=template&id=27fa1825"
import script from "./mvt-checkbox.js?vue&type=script&lang=js"
export * from "./mvt-checkbox.js?vue&type=script&lang=js"

import "./mvt-checkbox.vue?vue&type=style&index=0&id=27fa1825&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__